<template>
    <div class="loader-icon-small-container">
        <div
            class="loading-icon"
            :style="overrideStyles"
        />
    </div>
</template>

<script>
export default {
    name: 'LoaderIconSmall',
    props: {
        overrideStyles: {
            type: Object,
            required: false,
            default: () => ( {} ),
        },
    },
};
</script>

<style scoped>
.loader-icon-small-container {
    display: flex;
    justify-content: space-around;
    align-items: center;
    top: 5%;
}

.loading-icon {
    border-radius: 50%;
    width: 25px;
    height: 25px;
    border: 5px solid #ddd;
    border-top-color: #333;
    display: inline-block;
    margin: 0 8px;
    animation-name: spin;
    animation-timing-function: linear;
    animation-duration: 1s;
    animation-iteration-count: infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
